import { createTheme } from '@material-ui/core';

export default createTheme({
  palette: {
    primary: {
      disabled: '#d3e7ff',
      idle: '#6aafff',
      hover: '#5ca8ff',
      pressed: '#479dff',
      darker: '#344867',
      main: '#4a74a5',
    },
    secondary: {
      disabled: '#e4d8c9',
      idle: '#a57b4a',
      hover: '#9b7346',
      pressed: '#8d693f',
      main: '#a57b4a',
    },
    common: {
      yellow: '#ffa700',
      topaz: '#12adc4',
      green: '#6fc412',
      magenta: '#ff00de',
      modal: 'rgba(134, 72, 96, 0.8)',
      scrollbar: '#ffa700',
    },
  },
});
